import { derived } from 'svelte/store';

import { cmsConfig } from '$lib/services/config';

/**
 * Whether the GitBase AI assistant is enabled in `gitbase.config.yml`.
 * @example
 * ai-agent:
 *   show: true
 * @type {import('svelte/store').Readable<boolean>}
 */
export const isAiAgentEnabled = derived(cmsConfig, ($config) => {
  const aiAgent = /** @type {{ show?: boolean } | undefined} */ ($config?.['ai-agent']);

  return aiAgent?.show === true;
});
